import axios from 'axios';
import { getUserData } from './storageService';

const API_URL = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/penalty`
  : 'https://backend-c-0mxm.onrender.com/api/penalty';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const user = getUserData();
  if (user) {
    // Backend coi Bearer là userId thô (xem middlewares/auth.js) — userId phải đứng TRƯỚC token
    config.headers.Authorization = `Bearer ${user.userId || user.token}`;
  }
  return config;
});

const handleError = (error) => {
  if (error.response) {
    return { message: error.response.data.message || 'Có lỗi xảy ra', status: error.response.status };
  }
  if (error.request) {
    return { message: 'Không thể kết nối đến server', status: 0 };
  }
  return { message: 'Có lỗi xảy ra', status: 0 };
};

// params: { userId, monthKey, status } hoặc { userId, from, to }
export const getPenalties = async (params = {}) => {
  try {
    const response = await api.get('/', { params });
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

// Số liệu từng tháng vi phạm: GMV, thưởng đã nhận, phiếu doanh thu. params.months = 'YYYY-MM,YYYY-MM'
export const getPenaltyContext = async (userId, params = {}) => {
  try {
    const response = await api.get(`/context/${userId}`, { params });
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

// Các tháng người này có dữ liệu, để admin chọn thay vì phải nhớ
export const getPenaltyMonths = async (userId) => {
  try {
    const response = await api.get(`/months/${userId}`);
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

// Ra quyết định: trừ GMV ảo, tính lại lương, gửi thông báo phạt ngay
export const createPenalty = async (payload) => {
  try {
    const response = await api.post('/', payload);
    return {
      success: true, data: response.data.data, message: response.data.message,
      computed: response.data.computed, warnings: response.data.warnings,
    };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const updatePenalty = async (id, payload) => {
  try {
    const response = await api.put(`/${id}`, payload);
    return {
      success: true, data: response.data.data, message: response.data.message,
      computed: response.data.computed, warnings: response.data.warnings,
    };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

// Thu hồi quyết định: hoàn nguyên doanh thu + tiền phạt + thưởng bị cắt
export const revokePenalty = async (id, resolutionNote) => {
  try {
    const response = await api.post(`/${id}/revoke`, { resolutionNote });
    return { success: true, data: response.data.data, message: response.data.message, warnings: response.data.warnings };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

// Nhân sự gửi giải trình cho quyết định của chính mình
export const appealPenalty = async (id, appealNote) => {
  try {
    const response = await api.post(`/${id}/appeal`, { appealNote });
    return { success: true, data: response.data.data, message: response.data.message };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const deletePenalty = async (id) => {
  try {
    const response = await api.delete(`/${id}`);
    return { success: true, message: response.data.message, warnings: response.data.warnings };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};
